import React from 'react';
import { useMutation, useParameterizedQuery } from 'react-fetching-library';
import Page from '../../components/Page';
import { Box, Card, CardContent, List, ListItem, ListItemText, IconButton, useMediaQuery, Menu, MenuItem, Typography, Stack, CardHeader, Button, Divider } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CheckIcon from '@mui/icons-material/Check';
import { downloadStaffAdditionalDocumentAction, updateAdditionalDocumentAction } from '../../services/request';
import Scrollbar from '../../components/Scrollbar';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { plPL } from '@mui/x-data-grid';
import { staffAdditionalDocumentsColumns } from '../../services/column-definitions';
import toast from 'react-hot-toast';
import { useStaff } from '../../pages/Staff';
import { useManager } from '../../pages/Manager';
import DocumentForm from './additional-documents/DocumentForm';
import PDFPreviewModal from '../employee/applications/applicationForm/tabs/documents/PDFPreviewModal';

export default function StaffAdditionalDocuments ({ manager }) {
  const { application, setApplication } = manager ? useManager() : useStaff();
  const isMobile = useMediaQuery('(max-width:600px)');
  const { query } = useParameterizedQuery(downloadStaffAdditionalDocumentAction);
  const { mutate } = useMutation(updateAdditionalDocumentAction);
  const [openAddDocument, setOpenAddDocument] = React.useState(false);
  const [previewUrl, setPreviewUrl] = React.useState(null);

  const [anchorElStaff, setAnchorElStaff] = React.useState(null);
  const [menuRowStaff, setMenuRowStaff] = React.useState(null);

  const [anchorElOffice, setAnchorElOffice] = React.useState(null);
  const [menuRowOffice, setMenuRowOffice] = React.useState(null);

  const handleMenuOpenStaff = (event, row) => {
    setAnchorElStaff(event.currentTarget);
    setMenuRowStaff(row);
  };

  const handleMenuOpenOffice = (event, row) => {
    setAnchorElOffice(event.currentTarget);
    setMenuRowOffice(row);
  };

  const handleMenuCloseStaff = () => {
    setAnchorElStaff(null);
    setMenuRowStaff(null);
  };

  const handleMenuCloseOffice = () => {
    setAnchorElOffice(null);
    setMenuRowOffice(null);
  };

  const handleDownload = async (row, preview = false) => {
    const { payload, error, loading } = await query(row.id);

    if (!error) {
      if (preview) {
        setPreviewUrl(window.URL.createObjectURL(payload));
      } else {
        const url = window.URL.createObjectURL(payload);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = `${row.file_name}`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } else {
      toast.error('Nie udało się pobrać szablonu');
    }
  };

  const handleAddDocument = newDoc => {
    setApplication(prev => ({ ...prev, staff_documents_added_by_staff: [...prev.staff_documents_added_by_staff, newDoc] }));
  };

  const handleCheckDocument = async row => {
    const { payload, error, loading } = await mutate({ confirmed_by_staff: true }, row.id);
    if (!error && !loading) {
      setApplication(prev => ({ ...prev, staff_documents_added_by_office: prev.staff_documents_added_by_office.map(sd => sd.id == payload.id ? payload : sd) }));
      toast.success('Oznaczono zapoznanie z dokumentem');

    }
  };

  if (!application) {
    return null;
  }

  return (
    <Page title="Dokumenty Dodatkowe">
      <Stack direction="column" spacing={2} mt={1}>
        <Card sx={{ width: '100%' }}>
          <CardHeader title={
            <Stack direction="row" alignItems="center">
              <Typography variant="h6">Dokumenty Dodane przez Ciebie&nbsp;</Typography>
              <Button size="small" variant="contained" onClick={() => setOpenAddDocument(true)}>
              Dodaj Plik
              </Button>
            </Stack>} />
          <CardContent >
            {isMobile ? (
              <>
                <List>
                  {application.staff_documents_added_by_staff.map(row => (
                    <ListItem key={row.id} divider>
                      <ListItemText primary={<Typography><b>Dokument:</b> {row.name}</Typography>} secondary={<Stack direction="column">
                        <Divider flexItem />
                        <Typography><b>Plik:</b> {row.file_name}</Typography>
                        <Typography><b>Opis:</b> {row.description}</Typography>
                        <Typography><b>Zapoznany przez biuro:</b> {row.confirmed_by_office ? 'Tak' : 'Nie'}</Typography>
                      </Stack>} />
                      <IconButton onClick={event => handleMenuOpenStaff(event, row)}>
                        <MoreVertIcon />
                      </IconButton>
                    </ListItem>
                  ))}
                </List>
                <Menu anchorEl={anchorElStaff} open={Boolean(anchorElStaff)} onClose={handleMenuCloseStaff}>
                  {menuRowStaff?.can_preview && (
                    <MenuItem onClick={() => {
                      handleDownload(menuRowStaff, true);
                      handleMenuCloseStaff();
                    }}>
                      <RemoveRedEyeIcon style={{ marginRight: 8 }} /> Pokaż
                    </MenuItem>
                  )}
                  <MenuItem onClick={() => {
                    handleDownload(menuRowStaff);
                    handleMenuCloseStaff();
                  }}>
                    <FileDownloadIcon style={{ marginRight: 8 }} /> Pobierz Plik
                  </MenuItem>
                </Menu>

              </>
            ) : (
              <Scrollbar>
                <Box sx={{ minWidth: { md: 800 }, mt: 4 }}>
                  <DataGridPro
                    columns={staffAdditionalDocumentsColumns(handleDownload)}
                    rows={application.staff_documents_added_by_staff}
                    density="standard"
                    disableColumnMenu={true}
                    autoPageSize={false}
                    autoHeight={true}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    pagination
                    components={{
                      Toolbar: null
                    }}
                    localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
                    disableSelectionOnClick

                  />
                </Box>
              </Scrollbar>
            )}
          </CardContent>
        </Card>

        <Card sx={{ width: '100%' }}>
          <CardHeader title="Dokumenty Dodane przez biuro" />
          <CardContent>
            {isMobile ? (
              <>
                <List>
                  {application.staff_documents_added_by_office.map(row => (
                    <ListItem key={row.id} divider>
                      <ListItemText primary={<Typography><b>Dokument:</b> {row.name}</Typography>} secondary={<Stack direction="column">
                        <Divider flexItem />
                        <Typography><b>Plik:</b> {row.file_name}</Typography>
                        <Typography><b>Opis:</b> {row.description}</Typography>
                      </Stack>} />
                      <IconButton onClick={event => handleMenuOpenOffice(event, row)}>
                        <MoreVertIcon />
                      </IconButton>
                    </ListItem>
                  ))}
                </List>
                <Menu anchorEl={anchorElOffice} open={Boolean(anchorElOffice)} onClose={handleMenuCloseOffice}>
                  {menuRowOffice?.can_preview && (
                    <MenuItem onClick={() => {
                      handleDownload(menuRowOffice, true);
                      handleMenuCloseOffice();
                    }}>
                      <RemoveRedEyeIcon style={{ marginRight: 8 }} /> Pokaż
                    </MenuItem>
                  )}
                  <MenuItem onClick={() => {
                    handleDownload(menuRowOffice);
                    handleMenuCloseOffice();
                  }}>
                    <FileDownloadIcon style={{ marginRight: 8 }} /> Pobierz Plik
                  </MenuItem>
                  <MenuItem
                    disabled={menuRowOffice?.confirmed_by_staff}
                    onClick={() => {
                      handleCheckDocument(menuRowOffice);
                      handleMenuCloseOffice();
                    }}
                  >
                    <CheckIcon style={{ marginRight: 8 }} /> {menuRowOffice?.confirmed_by_staff ? 'Potwierdzono' : 'Potwierdź'}
                  </MenuItem>
                </Menu>

              </>
            ) : (
              <Scrollbar>
                <Box sx={{ minWidth: { md: 800 }, mt: 4 }}>
                  <DataGridPro
                    columns={staffAdditionalDocumentsColumns(handleDownload, handleCheckDocument)}
                    rows={application.staff_documents_added_by_office}
                    density="standard"
                    disableColumnMenu={true}
                    autoPageSize={false}
                    autoHeight={true}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    pagination
                    components={{
                      Toolbar: null
                    }}
                    localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
                    disableSelectionOnClick

                  />
                </Box>
              </Scrollbar>
            )}
          </CardContent>
        </Card>
      </Stack>
      <DocumentForm
        open={openAddDocument}
        handleClose={() => setOpenAddDocument(false)}
        handleAddDocument={handleAddDocument}
        applicationId={application.id} />
      {previewUrl !== null ? <PDFPreviewModal url={previewUrl} handleClose={() => setPreviewUrl(null)}/> : null}
    </Page>
  );
};
